import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { isBrowser } from '@jelly/utils'

const BelowFoldMarker = styled.div`
	position: absolute;
	width: 1px;
	height: ${({ bodyHeight }) => `calc(${bodyHeight}px - 200vh)`};
	top: 200vh;
	left: 0;
	visibility: hidden;
`

RenderBelowFold.propTypes = {
	children: PropTypes.node.isRequired,
}

export function RenderBelowFold({ children }) {
	const [belowFoldRef, belowFoldInView] = useInView()
	const bodyHeight = isBrowser() ? document.body.clientHeight : 0

	return (
		<>
			<BelowFoldMarker ref={belowFoldRef} bodyHeight={bodyHeight} />

			{belowFoldInView && children}
		</>
	)
}
